import { l as lodash } from './lodash-5c867657.js';
import { f as forceUpdate } from './index-78f24412.js';
import { a as mapStateToQueryParam } from './mo-utils-eb97378b.js';

/* For setting up addons during component initialization. */
const setupAddOns = (component, options = {}) => {
    // For deep-linking by binding component state to URL params.
    if (options.deepLinking && component.deepLinkingStates) {
        // For example, @Prop() deepLinkingStates = { query: 'q' }
        // will sync component prop `query` with query param `q`.
        lodash.each(component.deepLinkingStates, (urlParam, componentState) => {
            mapStateToQueryParam(component, componentState, urlParam);
        });
    }
};
const forceUpdateElement = (element) => {
    if (element) {
        forceUpdate(element);
    }
};

const componentUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    setupAddOns: setupAddOns,
    forceUpdateElement: forceUpdateElement
});

export { componentUtils as c, forceUpdateElement as f };
